/* Olyra funnels v2 : choix du lot + compte à rebours (fin fixée à la 1re visite, jamais remise à zéro) */
(function () {
  function initOffers(root) {
    root.querySelectorAll('[data-oa2-offer]').forEach(function (o) {
      if (o.dataset.oa2Ready) return; o.dataset.oa2Ready = '1';
      var go = o.querySelector('[data-oa2-go]'), url = o.dataset.url;
      o.querySelectorAll('.oa2-pack').forEach(function (p) {
        p.addEventListener('click', function () {
          o.querySelectorAll('.oa2-pack').forEach(function (q) { q.classList.remove('is-on'); q.setAttribute('aria-checked', 'false'); });
          p.classList.add('is-on'); p.setAttribute('aria-checked', 'true');
          if (go && p.dataset.variant) go.href = url + '?variant=' + p.dataset.variant;
        });
      });
    });
  }
  var KEY = 'oa2-deal-end', end;
  try { end = parseInt(localStorage.getItem(KEY), 10); } catch (e) {}
  if (!end) { end = Date.now() + 15 * 60 * 1000; try { localStorage.setItem(KEY, String(end)); } catch (e) {} }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = Math.max(0, Math.round((end - Date.now()) / 1000));
    var t = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    document.querySelectorAll('[data-oa2-timer]').forEach(function (el) { el.textContent = t; });
    if (left <= 0) clearInterval(iv);
  }
  var iv;
  function start() { initOffers(document); if (document.querySelector('[data-oa2-timer]')) { tick(); iv = setInterval(tick, 1000); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { initOffers(e.target); tick(); });
})();
